module.exports = __webpack_public_path__ + "static/media/np.d01e1cf8.png";